import { INotification } from "../../models";

export enum NotificationActions {
  SHOW = "SHOW",
  DISMISS = "DISMISS",
}

export interface Show {
  type: NotificationActions.SHOW;
  payload: INotification;
}
export interface Dismiss {
  type: NotificationActions.DISMISS;
  payload: string;
}

export const dispatchShow =
  (payload: INotification) => (dispatch, _getState) => {
    return dispatch({ type: NotificationActions.SHOW, payload } as Show);
  };
export const dispatchDismiss = (payload: string) => (dispatch, _getState) => {
  return dispatch({ type: NotificationActions.DISMISS, payload } as Dismiss);
};
